import React from "react";
import Box from "components/common/Box";
import JarvisButton from "components/JarvisButton";
import { authPrimaryButtonSx } from "./authFieldStyles";

const AuthPrimaryButton = ({
  children,
  onClick,
  loading = false,
  disabled = false,
  showArrow = false,
  product,
  sx = {},
  ...rest
}) => {
  return (
    <JarvisButton
      sx={{ ...authPrimaryButtonSx, ...sx }}
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      product={product}
      disableEndIcon={!showArrow}
      endIcon={
        showArrow ? (
          <Box
            component="img"
            src="/images/signup/arrow-right.svg"
            alt=""
            sx={{ width: 20, height: 20, display: "block" }}
          />
        ) : null
      }
      {...rest}
    >
      {children}
    </JarvisButton>
  );
};

export default AuthPrimaryButton;
